import React from "react";

export default class SpecialDayInput extends React.Component {
  render() {
    if (this.props.startDate === null) {
      return (
        <input
          className="input"
          readOnly
          value=""
          onClick={this.props.onClick}
        />
      );
    }
    if (this.props.startDate !== null && this.props.endDate === null) {
      return (
        <input
          className="input"
          value={this.props.startDate.format("DD/MM/YYYY")}
          onClick={this.props.onClick}
          readOnly
        />
      );
    }
    return (
      <input
        className="input"
        readOnly
        value={`${this.props.startDate.format(
          "DD/MM/YYYY"
        )}-${this.props.endDate.format("DD/MM/YYYY")}`}
        onClick={this.props.onClick}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/utilities/SpecialDayInput.js